import { Component, ElementRef, EventEmitter, Output, ViewChild,ChangeDetectorRef } from '@angular/core';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import { FlightService } from 'src/app/services/flight.service';
import { DataService } from 'src/app/services/data.service';
import { MatStepper } from '@angular/material/stepper';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatSelectionList } from '@angular/material/list';
import { DomSanitizer} from '@angular/platform-browser';
import { SettingsService } from 'src/app/services/settings.service';
import {TestComponent} from 'src/app/components/test/test.component'
import {CarrierCodeService} from '../../services/carrier-code.service';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import {HotelService} from 'src/app/services/hotel.service'
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-hotel-manual-payment-detail',
  templateUrl: './hotel-manual-payment-detail.component.html',
  styleUrls: ['./hotel-manual-payment-detail.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {displayDefaultIndicatorType: false},
    },
  ],
})
export class HotelManualPaymentDetailComponent {
  currentStep: number = 3;
  totalBalance:any
  nextStep() {
    this.currentStep = Math.min(this.currentStep + 1, 3);
  }

  stepClick(item:any){
    this.currentStep=item
    this.acknowledge=true
    // this.order.portMessage.subscribe((message:any) => {
    //   this.orderId = message
    //   // this.dataEntitylist(this.orderId)
  
    // })
    // Assuming "deposit" is the value you want to auto-select
    console.log(this.orderId)
    let mapstatus:any=[]
    mapstatus=this.orderId.paymentConfig.status.filter((map:any)=>map.isBusinessEnabled===true)
    // console.log(mapstatus)
    const depositOption = this.PaymentType?.options.find((option:any) => option?.value === mapstatus[0].mediumName);
    
    if (depositOption) {
      depositOption._setSelected(true); // Use _setSelected to programmatically select the option
    }
    this.cdr.detectChanges();
    this.OrderId()
  }
  prevStep() {
    this.currentStep = Math.max(this.currentStep - 1, 1);
  }

  @ViewChild('PaymentType') PaymentType!: MatSelectionList;

  // @ViewChild(MatStepper) stepper!: MatStepper;
  
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  
  @Output() flightBooking:EventEmitter<string>= new EventEmitter();  
  @Output() hideSideBar:EventEmitter<string>= new EventEmitter();
  userUuid:any
  
  acceptTerm:any='true'
  outputMessage:string="close";
  showSpiner:boolean=false
  showNext:boolean=false
  pnrNo:any
  pnrData:any
  flightList:any
  orderId:any
  showMore:any
  carrierCode = []
  loginUserType:any=''
firstFormGroup = this._formBuilder.group({
  firstCtrl: ['', Validators.required],
});
secondFormGroup = this._formBuilder.group({
  secondCtrl: '',
});
isOptional = false;
userType:any
constructor(private UserService:UserService,private HotelService:HotelService,private SettingsService:SettingsService,private sanitizer :DomSanitizer,private cdr: ChangeDetectorRef,private CarrierCodeService:CarrierCodeService,
   private userInfoService : UserInfoService, private toastMsgService : ToastmsgService,  private dialogService : DialogService,
  private _formBuilder: FormBuilder,private FlightService:FlightService,private order:DataService,private PaymentConfigService:PaymentConfigService,private DataEntityService:ReportingConfigService) {
    this.ENABLE_TRIP_MGMT()
    this.userType=userInfoService.getUserType();
    this.userType=this.userType.toUpperCase()
    this.carrierCode=this.CarrierCodeService.carrierCode()

  this.order.portMessage.subscribe((message:any) => {

    this.orderId = message
    this.dataEntitylist(this.orderId)
    if(this.orderId?.bookingId){
      // console.log(this.orderId?.pnr)
      // this.pnrNo=this.orderId?.pnr
      this.orderId.orderNumber=this.orderId.orderUId

      this.showNext=true
      this.test=true

      this.pnrRetreive()
      
      // this.hideSideBar.emit(this.outputMessage);
  
  
     
      // this.showNext=true
     
      // this.currentStep=2
        }else{
          this.mapRoomsToGuests()
        }
  })
  
  this.userUuid=this.userInfoService.getUserUuid()

// console.log(this.userUuid)

this.loginUserType=sessionStorage.getItem('loginUserType')
this.loginUserType=this.loginUserType.toUpperCase()

console.log(this.loginUserType)


}
backClick(){
  window.location.reload()
  this.myOutput.emit(this.outputMessage);
}

booking(){
  // this.getFlightList()
  // this.flightBooking.emit(this.outputMessage);
  this.bookingData()
}

bookingData(){
  this.showSpiner=true
  this.HotelService
  .hotelManualBooking(this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {

      this.showSpiner=false
      if(res) {
       let data:any
       data=res?.result  
       //this.firstFormGroup.value.firstCtrl=data.pnrNumber
      //  this.firstFormGroup = this._formBuilder.group({
      //   firstCtrl: [data?.pnrNumber, Validators.required],
        
      // });
      let pnrData:any=''

if(data){
  // console.log(res)
  if(data.expediaBookingResponse){
    data.expediaBookingResponse.forEach((item:any)=>{
      
      if( res.resStatus==="OK"){
        this.showNext=true

        this.test=true

        this.hideSideBar.emit(this.outputMessage);

        this.pnrNo=item?.pnrNumber

        this.pnrRetreive()
        // this.showNext=true
       
        // this.currentStep=2
        // pnrData+=item?.fromAirport +' to '+ item?.toAirport+ " PNR ("+this.pnrNo+") has been successfully generated ! \n"

        // pnrData+=`Your Booking is Completed with BookingId - `+item?.itineraryId+`  \nYou will soon receive an email confirmation\nThank you for Booking with us ! \n`
        // this.toastMsgService.setMsg({msg : pnrData,msgTitle:  "Success", msgType : "I"});

        this.dialogService.open({msg : `Your Booking is Completed with Cart Id - `+this.orderId.orderNumber+`  \nYou will soon receive an email confirmation\nThank you for Booking with us ! `,title : "Confirmation",buttonType : "Ok"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="OK") {
          


          }})
          
      }else if(res.resStatus==="BAD_REQUEST"){

        // this.showNext=true
        // this.test=true
        // this.pnrRetreive()

        if(item?.errorDetails?.errorData?.errorMessage==="Price changed"){

          pnrData +=item?.fromAirport +` to `+ item?.toAirport + `(`+ `Price Jumped You Still to Continue`+`)! \n`
          // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
   this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "priceChange"})
         
          this.dialogService.onResponse((response :  string) => {
           
            if(response=="Back to Search Page") {
              // window.location.href="/app/flight"
                window.close();
  
            }else if(response=="Accepted"){
              window.location.reload()

            }})



        }else{

         pnrData +=item?.fromAirport +` to `+ item?.toAirport + `(`+ item?.errorDetails?.errorData?.errorMessage+`)! \n`
        // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
 this.dialogService.open({msg : 'Booking Failed',title : "Warning",buttonType : "tag"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            // window.location.href="/app/flight"


           
              window.close();

            


            
          }})}
      }else if(res.resStatus==="CONFLICT"){
        // this.pnrRetreive()
        // this.showNext=true
        pnrData +=item?.errorDetails?.errorData
        // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
 this.dialogService.open({msg : 'Booking Failed',title : "Warning",buttonType : "tag"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            // window.location.href="/app/flight"


           
              window.close();

            


            
          }})
      }

    
  })}

  if(data.mmtBookingResponse){

  // +++++++++++++++++++++++++++++++++++++++++++++++
      data.mmtBookingResponse.forEach((item:any)=>{
      
      if( res.resStatus==="OK"){
        this.showNext=true

        this.test=true

        this.hideSideBar.emit(this.outputMessage);

        this.pnrNo=item?.pnrNumber

        this.pnrRetreive()
        // this.showNext=true
       
        // this.currentStep=2
        // pnrData+=item?.fromAirport +' to '+ item?.toAirport+ " PNR ("+this.pnrNo+") has been successfully generated ! \n"

        // pnrData+=`Your Booking is Completed with BookingId - `+item?.bookingId+`  \nYou will soon receive an email confirmation\nThank you for Booking with us ! \n`
        // this.toastMsgService.setMsg({msg : pnrData,msgTitle:  "Success", msgType : "I"});

        this.dialogService.open({msg : `Your Booking is Completed with Cart Id - `+this.orderId.orderNumber+`  \nYou will soon receive an email confirmation\nThank you for Booking with us ! `,title : "Confirmation",buttonType : "Ok"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="OK") {
          


          }})
          
      }else if(res.resStatus==="BAD_REQUEST"){

        // this.showNext=true
        // this.test=true
        // this.pnrRetreive()

        if(item?.errorDetails?.errorData?.errorMessage==="Price changed"){

          pnrData +=item?.fromAirport +` to `+ item?.toAirport + `(`+ `Price Jumped You Still to Continue`+`)! \n`
          // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
   this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "priceChange"})
         
          this.dialogService.onResponse((response :  string) => {
           
            if(response=="Back to Search Page") {
              // window.location.href="/app/flight"
                window.close();
  
            }else if(response=="Accepted"){
              window.location.reload()

            }})



        }else{

         pnrData +=item?.fromAirport +` to `+ item?.toAirport + `(`+ item?.errorDetails?.errorData?.errorMessage+`)! \n`
        // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
 this.dialogService.open({msg : 'Booking Failed',title : "Warning",buttonType : "tag"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            // window.location.href="/app/flight"


           
              window.close();

            


            
          }})}
      }else if(res.resStatus==="CONFLICT"){
        // this.pnrRetreive()
        // this.showNext=true
        pnrData +=item?.errorDetails?.errorData
        // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
 this.dialogService.open({msg : 'Booking Failed',title : "Warning",buttonType : "tag"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            // window.location.href="/app/flight"


           
              window.close();

            


            
          }})
      }

    })}}else{

      // this.pnrRetreive()
      // this.test=true
      this.dialogService.open({msg : "Booking Failed !",title : "Warning",buttonType : "tag"})
     
      this.dialogService.onResponse((response :  string) => {
       
        if(response=="Back to Search Page") {
          // window.location.href="/app/hotel"

          window.close();

          
        }})
    }
    
      } else {  


   
        this.dialogService.open({msg : "Booking Failed !",title : "Warning",buttonType : "tag"})
     
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            // window.location.href="/app/flight"

            window.close();

            
          }})

      //   let pnrData:any
      //   pnrData=res?.message
      //   if(pnrData){
      //     this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "tag"})
       
      //     this.dialogService.onResponse((response :  string) => {
           
      //       if(response=="Back to Search Page") {
            
      //         window.location.href="/app/flight"

              
      //       }})
        
      // }else{
      //   this.dialogService.open({msg : 'PNR not generated !',title : "Warning",buttonType : "tag"})
       
      //   this.dialogService.onResponse((response :  string) => {
         
      //     if(response=="Back to Search Page") {
          
      //       window.location.href="/app/flight"

            
      //     }})
      // }
      } 
    },error : (err) => {
      this.showSpiner=false
        this.dialogService.open({msg : "Booking Failed !",title : "Warning",buttonType : "tag"})
     
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            // window.location.href="/app/flight"

            window.close();

            
          }})
      // this.toastMsgService.setMsg({msg : "PNR not generated !",msgTitle:  "Warning", msgType : "W"});

    }
  }
)
}

pnrRetreive(){
  this.showMore=true
  this.FlightService.getAllHotelData(this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {
      if(res) {
        this.showMore=false

       let data:any
       data=res  
       this.pnrData=data
    //    this.pnrData={
    //     "clientName": "Demo Travel Management",
    //     "orderId": "STG290824100550951",
    //     "status": "B",
    //     "bookingID": "NH12015351032114",
    //     "gstNumber": "27AABCG4768C1ZR",
    //     "gstName": "DEMO TOURS AND TRAVEL MANAGEMENT INDIA PRIVATE LIMITED.",
    //     "gstEmail": "mohit@demotravelindia.com",
    //     "cabinClass": null,
    //     "modeOfPayment": "Cash",
    //     "priceData": {
    //         "totalBookingAmount": 103,
    //         "totalBaseAmount": 100,
    //         "airlineTaxes": null,
    //         "finalTaxes": 3,
    //         "commissionData": null,
    //         "markupData": null,
    //         "miscPriceData": null,
    //         "mealCharges": 0,
    //         "seatCharges": 0,
    //         "baggageSSRCharges": null,
    //         "specialSSRCharges": null,
    //         "preferenceCharges": null,
    //         "insurance": null,
    //         "incentiveAmt": null,
    //         "incentiveTds": null,
    //         "currency": null
    //     },
    //     "creationTime": "29-Aug-24 10:05",
    //     "invoiceItineraryList": [
    //         {
    //             "fromCode": null,
    //             "toCode": null,
    //             "fromCity": null,
    //             "toCity": null,
    //             "itineraryBookingId": "NH12015351032114",
    //             "itineraryAirlineGst": null,
    //             "itineraryAirlineGstAmt": null,
    //             "fareType": null,
    //             "bookingClass": null,
    //             "fareBasis": null,
    //             "gdsPnr": "null",
    //             "dealCode": null,
    //             "tourCode": null,
    //             "status": "Confirmed",
    //             "invoiceHotelDetails": null,
    //             "itineraryPassengers": [
    //                 {
    //                     "title": "MR",
    //                     "firstName": "Mohit",
    //                     "lastName": "Panwar",
    //                     "type": "ADT",
    //                     "pnr": "NH12015351032114",
    //                     "crsPnr": null,
    //                     "bookingClass": null,
    //                     "checkInBaggage": null,
    //                     "cabinBaggage": null,
    //                     "extraBaggage": null,
    //                     "freeMeal": false,
    //                     "ticket": null,
    //                     "seat": null,
    //                     "meal": null,
    //                     "totalPrice": null,
    //                     "mobile": "9871464882",
    //                     "email": "traveller@test.com",
    //                     "freqFlyerNumber": null,
    //                     "empId": null,
    //                     "barCode": null,
    //                     "carbonEmission": null
    //                 }
    //             ]
    //         }
    //     ],
    //     "airlineGstInfo": [
    //         {
    //             "segment": null,
    //             "gstNumber": null,
    //             "carrierName": null,
    //             "cgstAmt": 0,
    //             "sgstAmt": 0,
    //             "igstAmt": 0
    //         }
    //     ]
    // }
      //  this.pnrData.type="upload"
// console.log(this.pnrData)
      //  this.order.deliverMsg(this.pnrData)
       this.test=true
      //  this.mapRoomsBToGuests()
      //  setTimeout(() => {
      //    this.test=false
      //  }, 1);    
      } else {    
      } 
    },error : (err) => {
      
    //   this.pnrData={
    //     "clientName": "Demo Travel Management",
    //     "orderId": "STG290824100550951",
    //     "status": "B",
    //     "bookingID": "NH12015351032114",
    //     "gstNumber": "27AABCG4768C1ZR",
    //     "gstName": "DEMO TOURS AND TRAVEL MANAGEMENT INDIA PRIVATE LIMITED.",
    //     "gstEmail": "mohit@demotravelindia.com",
    //     "cabinClass": null,
    //     "modeOfPayment": "Cash",
    //     "priceData": {
    //         "totalBookingAmount": 103,
    //         "totalBaseAmount": 100,
    //         "airlineTaxes": null,
    //         "finalTaxes": 3,
    //         "commissionData": null,
    //         "markupData": null,
    //         "miscPriceData": null,
    //         "mealCharges": 0,
    //         "seatCharges": 0,
    //         "baggageSSRCharges": null,
    //         "specialSSRCharges": null,
    //         "preferenceCharges": null,
    //         "insurance": null,
    //         "incentiveAmt": null,
    //         "incentiveTds": null,
    //         "currency": null
    //     },
    //     "creationTime": "29-Aug-24 10:05",
    //     "invoiceItineraryList": [
    //         {
    //             "fromCode": null,
    //             "toCode": null,
    //             "fromCity": null,
    //             "toCity": null,
    //             "itineraryBookingId": "NH12015351032114",
    //             "itineraryAirlineGst": null,
    //             "itineraryAirlineGstAmt": null,
    //             "fareType": null,
    //             "bookingClass": null,
    //             "fareBasis": null,
    //             "gdsPnr": "null",
    //             "dealCode": null,
    //             "tourCode": null,
    //             "status": "Confirmed",
    //             "invoiceHotelDetails": null,
    //             "itineraryPassengers": [
    //                 {
    //                     "title": "MR",
    //                     "firstName": "Mohit",
    //                     "lastName": "Panwar",
    //                     "type": "ADT",
    //                     "pnr": "NH12015351032114",
    //                     "crsPnr": null,
    //                     "bookingClass": null,
    //                     "checkInBaggage": null,
    //                     "cabinBaggage": null,
    //                     "extraBaggage": null,
    //                     "freeMeal": false,
    //                     "ticket": null,
    //                     "seat": null,
    //                     "meal": null,
    //                     "totalPrice": null,
    //                     "mobile": "9871464882",
    //                     "email": "traveller@test.com",
    //                     "freqFlyerNumber": null,
    //                     "empId": null,
    //                     "barCode": null,
    //                     "carbonEmission": null
    //                 }
    //             ]
    //         }
    //     ],
    //     "airlineGstInfo": [
    //         {
    //             "segment": null,
    //             "gstNumber": null,
    //             "carrierName": null,
    //             "cgstAmt": 0,
    //             "sgstAmt": 0,
    //             "igstAmt": 0
    //         }
    //     ]
    // }
      this.showMore=false

    }
  }
)
}
convertToISOStringFormat(dateString:any) {
  // Remove the ' 00:00' part and then add 'Z' at the end
  const isoDateString = dateString?.replace('00.000 00:00', '00.000Z');
  return isoDateString;
}
timeFormate(date:any){
  date=this.convertToISOStringFormat(date)
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'hh:mma');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

}
airPortFilter(item:any){
    
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.name
return item}else{
  return item
}
}
cityFilter(item:any){
    
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.city
return item}else{
  return item
}
}
getFlightList(){
   
  this.FlightService
  .getFlightList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       this.flightList=data
   
      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}
converter(item:any){
  const totalMinutes = item ;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  item=`${hours}h ${remainingMinutes}m`
  return item
}
dateFormate(date:any){

  date=this.convertToISOStringFormat(date)
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
acceptFTerm:any='true'
termConditions(item:any){
  // console.log(this.acceptTerm)
  this.acceptTerm=item
  this.acceptFTerm=item
}
backFlight()
{
window.location.href="/app/hotel"
}
generateTicket(){
  this.HotelService
    .downloadPdf(this.orderId.orderNumber)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)

        //  var fileName = this.orderId.orderNumber+"_Invoice.pdf";
        //       var a = document.createElement("a");
        //         var blob = data;
        //         this.pdfFileName = fileName;
        //         var file = new Blob([blob], {type: 'application/pdf'});
        //         var fileURL = window.URL.createObjectURL(file);
        //         this.pdfblob = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        //         console.log( this.pdfblob)
        //         console.log( this.pdfFileName)

        var fileName = this.orderId.orderNumber + "_Voucher.pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
 a.download = fileName;
window.open(a.href, '_blank');

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
//a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }

GetBalance(){

  this.PaymentConfigService
  .getBalance(this.userUuid)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.totalBalance=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
openTooltip() {
  this.GetBalance()
  const tooltipElement = document.querySelector('.mat-tooltip');
  
  // Check if the tooltip is already open
  if (tooltipElement) {
    tooltipElement.classList.add('mat-tooltip-show');
  }
}
ngAfterViewInit() {
  this.order.portMessage.subscribe((message:any) => {
    this.orderId = message
    // this.dataEntitylist(this.orderId)

  })
  // Assuming "deposit" is the value you want to auto-select
  let mapstatus:any=[]
  mapstatus=this.orderId?.paymentConfig?.status?.filter((map:any)=>map.isBusinessEnabled===true)
  // console.log(mapstatus)
  const depositOption = this.PaymentType?.options.find((option:any) => option?.value === mapstatus[0].mediumName);
  
  if (depositOption) {
    depositOption._setSelected(true); // Use _setSelected to programmatically select the option
  }
  this.cdr.detectChanges();
  this.OrderId()
  
}

OrderId(){
  this.fopType=this.PaymentType?.selectedOptions?.selected[0]?.value;
  let request:any={}

  if(this.fopType==='VIRTUAL_CARD'){
    this.creditList()

    request["paymentMedium"]=this.PaymentType?.selectedOptions?.selected[0]?.value;
    request["cardNo"]=this.cardNo
  if(this.cardNo){
    this.HotelService
    .OrderManualId(this.orderId.orderNumber,request)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)
        
        } else {    
        } 
      },error : (err) => {
  
  
      }
    }
  )}
  
  }
  else{
    request["paymentMedium"]=this.PaymentType?.selectedOptions?.selected[0]?.value;

  
  this.FlightService
  .OrderId(this.orderId.orderNumber,request)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
      //  console.log(data)
      
      } else {    
      } 
    },error : (err) => {


    }
  }
)}

}
fligthNameFilter(item:any){
  if(item){
  let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0].flightName
   return flightName
 }}else{
  return item
 }
  }

  
  pdfFileName:any
  pdfblob:any
  generatePDF(){
    this.HotelService
    .downloadPdf(this.orderId.orderNumber)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)

       

        var fileName = this.orderId.orderNumber + "_Voucher.pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }
  @ViewChild(TestComponent) childComponent!: TestComponent;
  test:boolean=false
  print(){

this.pnrData.type="print"

    this.order.deliverMsg(this.pnrData)
    this.test=true

    setTimeout(() => {
      this.test=false
    }, 1);
   
      
  }
  download(){
    this.pnrData.type="download"

    this.order.deliverMsg(this.pnrData)
    this.test=true

    setTimeout(() => {
      this.test=false
    }, 1);
  }
  fopType:any
  cardNo:any
  CreditData:any

  onChageFop(){
    if(this.fopType==='CASH'){
    this.cardNo=""
    }else{
      this.creditList()
    }
  }
  cardData(item:any){
    

  this.OrderId()
  /*if(item.expiryDate){
  this.cardExpMonth=this.separateValues(item.expiryDate).month
  this.cardExpYear=this.separateValues(item.expiryDate).year
  }*/
  }
creditList(){

  this.PaymentConfigService
  .creditCardList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.CreditData=data
    //  console.log(this.CreditData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

flightlogoFilter(item:any){
  
  if(item){
     let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0]?.logo
   return flightName
 }
  }else{return item}
 }
 onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
showGstInfo:boolean=false
 onClickGstInfo(){
this.showGstInfo=!this.showGstInfo
 }
 showadvancePrice:boolean=false
 onClickPricing(){
  this.showadvancePrice=!this.showadvancePrice
}

formatTotalPrice(item:any) {
  const numericPrice = parseFloat(item);
  if (!isNaN(numericPrice)) {
    return numericPrice.toFixed(2) + ' INR';
  }
  return 'N/A';

}
DataEntity:any
billingEntity:any
dataEntitylist(orderId:any){
  // console.log(this.orderId)
  this.DataEntityService
 .listEntities(orderId?.paymentConfig?.userUid)
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.DataEntity=data
     let entity:any=[]
     if(this.orderId?.entityRefId){
     entity=this.DataEntity.filter((item:any)=>item.entityRefId===this.orderId?.entityRefId)
     this.billingEntity=entity[0]
    }
      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}

starArray(item:any){
  // console.log(item)

  let star=[]
  if(item){
    // console.log(item)
  for(let i=0;i<item;i++){
  star.push(i+1)
  }}

  // console.log(star)
  return star
}

calculateStayNights(firstDate: string, lastDate: string): number {
  const first = new Date(firstDate);
  const last = new Date(lastDate);

  // Calculate the difference in time
  const diffTime = last.getTime() - first.getTime();

  // Convert time difference to days
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  let totalDays:any=0
if(diffDays>1){
  totalDays= diffDays+" Night(s)"
}else{
  totalDays= diffDays+" Night"

}
  return totalDays;
}




parseCancellationPolicy (data: string) {
  const policy = [];

  const firstPeriod = data.match(/before (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
  const secondPeriod = data.match(/From (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}) .*? till (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
  const thirdPeriod = data.match(/After (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);

  if (firstPeriod) {
    policy.push({
      cancelOnOrAfter: `N/A (Before ${firstPeriod[1].split(' ')[0]})`,
      cancelOnOrBefore: firstPeriod[1],
      charges: '₹0.00 (Free Cancellation)'
    });
  }

  if (secondPeriod) {
    policy.push({
      cancelOnOrAfter: secondPeriod[1],
      cancelOnOrBefore: secondPeriod[2],
      charges: '100% of booking amount'
    });
  }

  if (thirdPeriod) {
    policy.push({
      cancelOnOrAfter: thirdPeriod[1],
      cancelOnOrBefore: 'Check-In',
      charges: '100% of booking amount'
    });
  }

  return policy;
};

cancellationType(value:any,type:any){

  if(type==='PBA'){
    const percentageValue = this.convertToPercentage(value);
    return percentageValue
   }else if(type==='NR'){
    const rupeeValue = this.convertToRupees(value);

   return rupeeValue
   }else{
    return ''
   }
}
convertToPercentage(value: string): string {
  const numberValue = parseFloat(value);
  if(numberValue===0){
return '₹0.00 (Free Cancellation)'
  }else{
  return `${numberValue}% of booking amount`;}
}
convertToRupees(value: string): string {
  const numberValue = parseFloat(value);
  return `₹${numberValue.toFixed(2)} per room per Night`;
}
cancellationFilter(item:any){
  const parts = item.split('.');
  let cancellationPolicies = parts.filter((part:any) => part.trim() !== '');
  return cancellationPolicies
}


mergedData:any = [];
supplierAcknowledge:boolean=true
agentAcknowledge:boolean=true
guestAcknowledge:boolean=true

onSupplierCheckboxChange(event: any,type:any) {
  if (event.checked) {
this.supplierAcknowledge=false
    // Add your logic here for when the checkbox is checked
  } else {
   this.supplierAcknowledge=true
   this.acknowledge=true

    // Add your logic here for when the checkbox is unchecked
  }
  if(this.loginUserType==='STAFF'){
    if(this.supplierAcknowledge===false&&this.agentAcknowledge===false&&this.guestAcknowledge===false){
      this.acknowledge=false
  
    }}else{
      if(this.supplierAcknowledge===false&&this.guestAcknowledge===false){
        this.acknowledge=false
    
      }
    }
}
onAgentCheckboxChange(event: any,type:any) {
  if (event.checked) {
    this.agentAcknowledge=false
    // Add your logic here for when the checkbox is checked
  } else {
     this.agentAcknowledge=true
     this.acknowledge=true

    // Add your logic here for when the checkbox is unchecked
  }
  if(this.loginUserType==='STAFF'){
  if(this.supplierAcknowledge===false&&this.agentAcknowledge===false&&this.guestAcknowledge===false){
    this.acknowledge=false

  }}else{
    if(this.supplierAcknowledge===false&&this.guestAcknowledge===false){
      this.acknowledge=false
  
    }
  }
}
onguestCheckboxChange(event: any,type:any) {
  if (event.checked) {
        this.guestAcknowledge=false
    // Add your logic here for when the checkbox is checked
  } else {
    this.guestAcknowledge=true
    this.acknowledge=true

    // Add your logic here for when the checkbox is unchecked
  }
  if(this.orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms){
  if(this.loginUserType==='STAFF'){
    if(this.supplierAcknowledge===false&&this.agentAcknowledge===false&&this.guestAcknowledge===false){
      this.acknowledge=false
  
    }}else{
      if(this.supplierAcknowledge===false&&this.guestAcknowledge===false){
        this.acknowledge=false
    
      }
    }}else{
      if(this.guestAcknowledge===false){
        this.acknowledge=false
    
      }
    }

}
specialArray(item:any){
  let data:any=[]
  if(item){
    data=item?.split(',')
  }
return data
}
acknowledge:boolean=true
mapRoomsToGuests() {
  this.mergedData=[]
  let travellerIndex = 0;
  // const assignedPassengers = new Set();

let rooms:any=[]



const assignedPassengers = new Set<string>();

// Function to create a unique key for a passenger
function getPassengerKey(passenger: any) {
return `${passenger.passengerTitle}-${passenger.firstName}-${passenger.lastName}`;
}
rooms=[...this.orderId.searchDetail.rooms]

rooms.forEach((room:any) => {
// Get unassigned adults (ADT) by checking the unique key
const adults = this.orderId.travellerDetails
  .filter((passenger:any) => 
    passenger.passengerType === 'ADT' && 
    !assignedPassengers.has(getPassengerKey(passenger))
  )
  .slice(0, room.adults); // Limit to the room's adult capacity

// Mark adults as assigned using the unique key
adults.forEach((adult:any) => assignedPassengers.add(getPassengerKey(adult)));

// Get unassigned children (CHD) and limit based on room's childrenAges length
const children = this.orderId.travellerDetails
  .filter((passenger:any) => 
    passenger.passengerType === 'CHD' && 
    !assignedPassengers.has(getPassengerKey(passenger))
  )
  .slice(0, room.childrenAges.length); // Limit to the number of children allowed by room

// Mark children as assigned using the unique key
children.forEach((child:any) => assignedPassengers.add(getPassengerKey(child)));

// Update room with assigned passengers
room.assignedAdults = adults.map((adult:any) => `${adult?.passengerTitle} ${adult?.firstName} ${adult?.lastName}`);
room.assignedChildren = children.map((child:any, index:number) => ({
  name: `${child?.passengerTitle} ${child?.firstName} ${child?.lastName}`,
  age: room.childrenAges[index] // Match age to the child
}));
if(this.orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms){
  const roomData:any = {
    roomType: this.orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms[0]?.name || 'N/A',
    mealPlan:  this.orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms[0]?.ratePlans[0]?.description || 'N/A',
    guests: room
  };
  this.mergedData.push(roomData)
}else if(this.orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms){
const roomData:any = {
          roomType: this.orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0]?.room_name || 'N/A',
          mealPlan:  this.orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0]?.description || 'N/A',
          guests: room
        };
        this.mergedData.push(roomData)
      }
});
}
submitRequest(){
  this.toastMsgService.setMsg({msg : "Submit Request Successfully!",msgTitle : "Success", msgType : "I"});

}
tripEnable:boolean=false
trip2Enable:any=''
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
          this.tripEnable=true
        }else 
        if(res.rule==='2'){
          this.tripEnable=false
          this.trip2Enable='enable'
                    }else{
          this.tripEnable=false

        }

       }
 
      }else{

      }},error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  
}
dateFormateTime(date:any){
  const parsedDate = new Date(date);
  // console.log(parsedDate)
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'dd-MM-yyyy hh:mm:ssa');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
mmtBaseFare(base:any,couponDiscount:any,hotelDiscount:any){
  let data:any=(base?(base):0)-(couponDiscount?(couponDiscount):0)-(hotelDiscount?(hotelDiscount):0)
return data
}
}
